import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { User } from '@apps/auth/domain/models/back/user';

export const BackAuthUsersInternalODataRequested = createAction(
    '[BACK-AUTH-USERS] Back Auth Users Internal OData Requested'
);

export const BackAuthUsersInternalODataLoaded = createAction(
    '[BACK-AUTH-USERS] Back Auth Users Internal OData Loaded',
    props<{ users: User[] }>()
);
export const BackAuthUsersInternalODataFailed = createAction(
    '[BACK-AUTH-USERS] Back Auth Users Internal OData Failed',
    props<{ err: any }>()
);
export const BackAuthUsersInternalQsWordSet = createAction(
    '[BACK-AUTH-USERS] Back Auth Users Internal QsWord Set',
    props<{ qsWord: string }>()
);
export const BackAuthUsersInternalIdentityUpdated = createAction(
    '[BACK-AUTH-USER] Back Auth Users External Identity Updated',
    props<{user: Update<User> }>()
);
export const BackAuthInternalUserHabsUpdated = createAction(
    '[BACK-AUTH-USER] Back Auth Internal User Habs Updated',
    props<{ user: Update<User> }>()
);
export const BackAuthUsersInternalUserActiveStatusUpdated = createAction(
    '[BACK-AUTH-USER] Back Auth Users Internal User Active Status Updated',
    props<{ userId: string; active: boolean; }>()
);
export const BackAuthUsersDeactivateInternalUserFailed = createAction(
    '[BACK-AUTH-USER] Back Auth Users Deactivate Internal User Failed'
);
export const BackAuthUsersActivateInternalUserFailed = createAction(
    '[BACK-AUTH-USER] Back Auth Users Activate Internal User Failed'
);
